// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@turnerBlueprint/App/SharedStyles/CartLineSharedStyles";
import { cartLineCardCondensedStyles } from "@turnerBlueprint/Overrides/Components/CartLineCardCondensed";
import { mergeWithCss, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

cartLineCardCondensedStyles.cartLineContainer = {
    leftActions: {
        css: css`
            grid-column: 1 / 2;
            grid-row: 1;
        `,
    },
    image: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
    description: {
        css: css`
            grid-column: 1/5;

            ${xScreen("lte", "md")} {
                grid-column: 2 / 8;
            }

            @media print {
                min-width: 90%;
                max-width: 90%;
            }
        `,
    },
    price: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 2 / 8;
                padding-bottom: 16px;
            }
        `,
    },
};

cartLineCardCondensedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
    container: {
        ...mergeWithCss(cartLineSharedStyles.productPartNumbers?.container, {
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
};

cartLineCardCondensedStyles.productInfoContainer = {
    css: css`
        display: flex;
        column-gap: 42px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            row-gap: 8px;
        }
    `,
};
cartLineCardCondensedStyles.price = {
    ...cartLineSharedStyles.productPrice,
};

cartLineCardCondensedStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cartLineCardCondensedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};
